import { render } from "./CompleteTraining.vue?vue&type=template&id=88999e70&scoped=true"
import script from "./CompleteTraining.vue?vue&type=script&lang=js"
export * from "./CompleteTraining.vue?vue&type=script&lang=js"

import "./CompleteTraining.vue?vue&type=style&index=0&id=88999e70&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88999e70"]])

export default __exports__